import React from "react";
import { useIsLoggedIn } from "@/features/auth/hooks/useIsLoggedIn";
import { useSignIn } from "@/features/auth/hooks/useSignIn";
import { Button } from "@picklebet/ui";
import { PageMessage } from "@picklebet/ui";

import { ReactComponent as WarningIcon } from "assets/illustrations/login-warning.svg";
import { useIsClient } from "@/hooks/useIsClient";

type RequiresAuthProps = {
  children: React.ReactNode;
  skeleton?: React.ReactNode;
};

const RequiresAuth = ({ children, skeleton = null }: RequiresAuthProps) => {
  const isLoggedIn = useIsLoggedIn();
  const { handleSignIn, isBiometricProcessing } = useSignIn();
  const isClient = useIsClient();

  if (!isClient) return skeleton;

  if (!isLoggedIn) {
    return (
      <PageMessage
        title={`You must log in to continue`}
        image={<WarningIcon />}
      >
        <Button loading={isBiometricProcessing} onClick={handleSignIn}>
          Log In
        </Button>
      </PageMessage>
    );
  }

  return <>{children}</>;
};

export { RequiresAuth };
